import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Wallet } from "lucide-react";

export default function Login() {
  const { user, login, checked } = useAuth();
  const [email, setEmail] = useState("admin@dompetku.local");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  if (checked && user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Selamat datang kembali!");
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="max-w-[380px] w-full mx-auto min-h-screen flex flex-col shadow-2xl"
      style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background:
          "linear-gradient(180deg, #1F4E5F 0%, #1F4E5F 55%, #f8fafc 55%, #f8fafc 100%)",
      }}
    >
      <div className="flex-1 flex flex-col px-6 pt-16">
        <div className="flex items-center gap-3 text-white">
          <div className="w-11 h-11 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center">
            <Wallet size={24} strokeWidth={2.2} />
          </div>
          <div>
            <div className="text-xl font-extrabold tracking-tight">DompetKu</div>
            <div className="text-[11px] text-white/70">
              Personal finance tracker
            </div>
          </div>
        </div>

        <h1 className="mt-14 text-white text-3xl font-extrabold tracking-tight leading-tight">
          Kelola keuangan
          <br />
          dengan tenang.
        </h1>
        <p className="mt-2 text-white/70 text-sm">
          Masuk untuk mulai mencatat pemasukan, pengeluaran, hutang, dan tabungan Anda.
        </p>

        <form
          onSubmit={onSubmit}
          className="mt-10 bg-white rounded-3xl shadow-xl p-5 space-y-4"
          data-testid="login-form"
        >
          <div>
            <label className="text-xs font-semibold text-slate-600">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-[#1F4E5F] focus:outline-none text-sm"
              placeholder="you@dompetku.local"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-[#1F4E5F] focus:outline-none text-sm"
              placeholder="••••••••"
            />
          </div>
          {err && (
            <div
              className="text-xs px-3 py-2 rounded-lg"
              style={{ backgroundColor: "#FCE4E4", color: "#C00000" }}
              data-testid="login-error"
            >
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full h-11 rounded-xl tap font-semibold text-sm text-white disabled:opacity-60"
            style={{ backgroundColor: "#1F4E5F" }}
          >
            {loading ? "Memuat..." : "Masuk"}
          </button>
          <p className="text-[11px] text-slate-400 text-center">
            Aplikasi single-user. Kredensial default sudah di-seed oleh sistem.
          </p>
        </form>
      </div>
      <div className="text-center text-[11px] text-slate-400 pb-6 pt-4">
        © {new Date().getFullYear()} DompetKu
        <div className="text-[10px] text-slate-400/80 mt-0.5">
          created by luckytech
        </div>
      </div>
    </div>
  );
}
